import React, {useEffect, useState, useRef} from 'react'
import {useSelector} from 'react-redux'
import classNames from 'classnames'
import AjaxButton from "../../../../form/ajax_button";
import useTranslation from "../../../../virtual_congress/effects/use_translation"
import {useVideoRoomEventFor} from "./utils";

export function ChatMessage({message, options, nameRepeated}) {
  const isClickable = options.onChatMessageNameClicked && options.isChatMessageNameClickable && options.isChatMessageNameClickable(message.tag_owner)

  const onChatMessageNameClicked = (options, tagOwner, isClickable) => {
    if (isClickable) {
      options.onChatMessageNameClicked(tagOwner)
    }
  }

  return <div className={"row video-room-message-row"}>
    <div className="col-12 video-room-message-container">
      <div className={"video-room-chat-message"}>
        {options?.showNames !== false && !nameRepeated &&
          <div className={classNames("video-room-chat-message-name", {
            "clickable": isClickable,
            moderator: message.tag_owner?.moderator
          })}
               onClick={() => onChatMessageNameClicked(options, message.tag_owner, isClickable)}>
            {options?.showNameInitials ? message.tag_owner.initials : message.tag_owner.name}
          </div>
        }
        <div className="video-room-chat-message-body">{message.body}</div>
      </div>
    </div>
  </div>
}

export default function Chat({videoRoom, options}) {
  const t = useTranslation(null, true)
  const chatMessageFromEvent = useVideoRoomEventFor(videoRoom, videoRoom.take_chat_messages_from, options?.overrideEvent)

  const tag_owner = useSelector(state => state.tagOwner)
  const messages = useSelector(state => state.videoRoomChat.messages)
  const chatUrl = useSelector(state => state.videoRoomChat.chatUrl).replace("@video_room_id@", videoRoom.id)

  const [message, setMessage] = useState("");
  const [keepScrolledBottom, setKeepScrolledBottom] = useState(true);
  const [delayMessage, setDelayMessage] = useState("")

  const sendButton = useRef(null);
  const inputFieldRef = useRef(null);
  const messageEndRef = useRef(null);
  const chatContainerRef = useRef(null);

  const filteredMessages = messages.filter(vcm => vcm.event_id === chatMessageFromEvent.id && (!vcm.tag_owner.shadow_banned || vcm.tag_owner.id === tag_owner.id))
  const displayMessages = filteredMessages.slice(self.length - 1000)

  const scrollToBottom = () => {
    if (keepScrolledBottom && chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }

  scrollToBottom()

  useEffect(() => {
    // Without timeout it does not scroll down initially - maybe because the dom is not rendered fully event tough useEffect is executed after the render cycle?
    setTimeout(() => {
      scrollToBottom()
    }, 800)
  }, [])

  useEffect(() => {
    scrollToBottom()
  }, [displayMessages, chatContainerRef])

  useEffect(() => {
    if (inputFieldRef.current) {
      inputFieldRef.current.focus()
    }
  }, [])

  const handleChatInput = (event) => {
    if (event.key === 'Enter' && !event.shiftKey && sendButton.current && event.target.value) {
      event.preventDefault()
      event.stopPropagation()
      sendButton.current.click()
    }
  }

  const addEmojiToChatMessage = (event) => {
    console.log(event.target.dataset.emoji)
    setMessage(message + event.target.dataset.emoji)
  }

  const onMessagesScrolled = (event) => {
    setKeepScrolledBottom(event.target.scrollTop + event.target.offsetHeight >= event.target.scrollHeight - 1)
  }
  let lastMessageName = null

  console.log("current_message", message)

  return <div className="row no-gutters video-room-chat-root-container">
    {options.header && options.header}
    <div className="col-12 video-room-chat-container" ref={chatContainerRef} onScroll={onMessagesScrolled}>
      {displayMessages.map((message, index) => {
        let nameRepeated = lastMessageName == message?.tag_owner?.name
        lastMessageName = message?.tag_owner?.name
        return <ChatMessage
          options={options}
          key={message.id}
          nameRepeated={nameRepeated}
          message={message}
        />
      })}
      <div className={"messageEndRef"} ref={messageEndRef}/>

    </div>
    {delayMessage != "" &&
      <div className="col-12">
        <div className="alert alert-danger">{delayMessage}</div>
      </div>
    }
    <div className="col-12">
      <div className="input-group video-room-chat-window-input-form-group">
        <textarea
          ref={inputFieldRef}
          className="form-control chat-form-input"
          type="text"
          style={{minHeight: "87px"}}
          onKeyDown={handleChatInput}
          autoComplete="off"
          maxLength="1000"
          placeholder={videoRoom.chat_input_prompt_placeholder || t("video_room.chat.input_prompt") || options.inputPrompt || "Write your message"}
          value={message}
          onChange={(event) => {
            setMessage(event.target.value)
          }}
        />
        {message && <div className="input-group-append">
          <AjaxButton
            buttonRef={sendButton}
            method="post"
            labelSending={videoRoom.chat_send_button_sending_text || t("video_room.chat.send_button_label_sending") || options.sendButtonLabelSending || "Sending ..."}
            className={classNames("btn btn-block btn-stream btn-sm d-flex align-items-center")}
            icon="fa-save"
            url={chatUrl}
            data={() => {
              return {
                event_id: chatMessageFromEvent?.id,
                message: message
              }
            }}
            label={videoRoom.chat_send_button_text || t("video_room.chat.send_button_label") || options.sendButtonLabel || "Send"}
            onSuccess={(data) => {
              if (data.data.message && data.data.status == "NOK") {
                if (data.data.type == "chat_message_delay") {
                  setDelayMessage(data.data.message)
                  setTimeout(() => {
                    setDelayMessage("")
                  }, 1500)
                } else {
                  alert(t("video_room.chat.send_error") || data.data.message || "Error while sending message")
                  console.log("Error while sending message", data.data)
                }
              } else {
                setMessage("")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error sending chat message", error)
            }}
          />
        </div>}
      </div>
    </div>
    {(!!videoRoom.chat_emoji_items || options?.showEmojis) &&
      <div className="col-12 d-flex justify-content-start pb-2 pt-2">
        {options?.showEmojis && options?.emojis &&
          options?.emojis.map((emoji) => {
            return (
              <span
                className="emoji mr-1 pointer"
                key={emoji}
                onClick={addEmojiToChatMessage}
                data-emoji={emoji}>
              {emoji}
            </span>
            )
          })}
        {videoRoom.chat_emoji_items && !options?.emojis && videoRoom.chat_emoji_items.split(",").map((emoji) => {
          return (
            <span
              className="emoji mr-1 pointer"
              key={emoji}
              onClick={addEmojiToChatMessage}
              data-emoji={emoji}>
              {emoji}
            </span>
          )
        })}
      </div>
    }
  </div>
}
